import { ActionType, getType } from 'typesafe-actions';

import * as shadowOrder from '../../actionCreators/shadowOrder';

export default function (
  state: string | null = null,
  action: ActionType<typeof shadowOrder>,
): string | null {
  switch (action.type) {
    case getType(shadowOrder.setShadowNotes): {
      const { value } = action.payload;
      return value || null;
    }
    default:
      return state;
  }
}
